import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import player, { LottiePlayer } from 'lottie-web';
import { LottieModule } from 'ngx-lottie';
import { FbLoaderComponent } from './components/loader.component';
import { GetLoaderJsonPipe } from './pipes/get-loader-json.pipe';

export function playerFactory(): LottiePlayer {
  return player;
}

@NgModule({
  imports: [CommonModule, LottieModule.forRoot({ player: playerFactory })],
  declarations: [FbLoaderComponent, GetLoaderJsonPipe],
  exports: [FbLoaderComponent],
  providers: [GetLoaderJsonPipe],
})
export class LoaderModule {}
